import React from "react";
import ValidatedMyAccountForm from "../../components/ValidatedMyAccountForm";
import { compose, graphql, Query } from "react-apollo";
import { login, updateUser } from "../../../api/queries/utilisateur.mutations";
import { notify } from "../../generic";
import { useAuthDispatch, useAuthState } from "../../Context";
import { useNavigate } from "react-router-dom";
import { getUtilisateur } from "../../../api/queries/utilisateur.queries";
import Loader from "../../components/Loader";

function DetailsCompte(props) {
  const dispatch = useAuthDispatch();
  const navigate = useNavigate();
  const authContext = useAuthState(); //read user de

  const { userDetails = {} } = authContext;
  const { id: utilisateurId, login, email, token } = userDetails;

  const _mutateLoginUser = async ({ email, password, validationToken }) => {
    try {
      return props
        .login({
          variables: {
            email,
            password
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.login;

          if (type === "success") {
            dispatch({ type: "REQUEST_LOGIN" });
            const { user } = JSON.parse(details);

            if (user.token) {
              dispatch({ type: "LOGIN_SUCCESS", payload: user });
              localStorage.setItem("currentUser", JSON.stringify(user));

              //     navigate(`/mon-compte`);
            }
          } else {
            notify("error", message);
            dispatch({ type: "LOGIN_ERROR", error: message });
          }
        });

      return;
    } catch (error) {
      console.log(error);
      notify("error", error.message);
      dispatch({ type: "LOGIN_ERROR", error: error });
    }
  };

  const _mutateUpdateUser = async ({
    id,
    firstName,
    lastName,
    email,
    password,
    phone
  }) => {
    try {
      return props
        .updateUser({
          variables: {
            id,
            firstName,
            lastName,
            email,
            password,
            phone: String(phone)
          }
        })
        .then(({ data }) => {
          const { type, message, details } = data.updateUser;

          if (type === "success") {
            notify("success", message);
            return _mutateLoginUser({ email, password });
          } else {
            notify("error", message);
          }
        });
    } catch (error) {
      console.log(error);
      notify("error", error.message);
      dispatch({ type: "LOGIN_ERROR", error: error });
    }
  };

  const handleUpdateProfile = async settings => {
    try {
      let response = await _mutateUpdateUser({
        id: utilisateurId,
        ...settings
      }); //loginUser action makes the request and handles all the neccessary state changes

      //  navigate("/mon-compte/");
    } catch (error) {
      notify("error", error.message);
    }
  };

  return (
    <Query
      query={getUtilisateur}
      variables={{ utilisateurId }}
      fetchPolicy="no-cache"
    >
      {({ loading, error, data = {}, refetch }) => {
        if (loading) return <Loader />;
        if (error) return "Erreur";

        const {
          firstName = "",
          lastName = "",
          phone = "",
          email = ""
        } = data.getUtilisateur;

        return (
          <div>
            {" "}
            <h1 className="dashboardTitle pushed">Détails du compte</h1>
            <div className="row pushedByMenu">
              <div className="col-md-12">
                <h3>Profil utilisateur</h3>
              </div>
              <div className="pushedContainer">
                <ValidatedMyAccountForm
                  firstName={firstName}
                  lastName={lastName}
                  phone={phone}
                  email={email}
                  handleSubmit={handleUpdateProfile}
                />
              </div>
            </div>
          </div>
        );
      }}
    </Query>
  );
}

export default compose(
  graphql(updateUser, {
    name: "updateUser"
  }),
  graphql(login, {
    name: "login"
  })
)(DetailsCompte);
